import {InputNumber, Select} from 'antd'

type Option = {
  value: string,
  label: string,
}

type UnitValue = {
  value?: number,
  unitType?: string,
}

type UnitSelectorProps = {
  value?: UnitValue,
  onChange?: (value: UnitValue) => void,
  unitTypeOptions: Option[],
  placeholder?: string,
  disabled?: boolean,
}

const getContainer = () => document.body

const UnitSelector: React.FC<UnitSelectorProps> = ({value = {}, onChange, unitTypeOptions, placeholder, disabled}) => {
  const unitTypeSelector = (
    <Select
      disabled={disabled}
      dropdownMatchSelectWidth={false}
      dropdownStyle={{zIndex: 1400}}
      getPopupContainer={getContainer}
      onChange={(unitType) => onChange?.({...value, unitType})}
      options={unitTypeOptions}
      placeholder='Unità'
      style={{minWidth: 110}}
      value={value.unitType}
    />
  )

  return (
    <InputNumber
      addonAfter={unitTypeSelector}
      disabled={disabled}
      min={0}
      onChange={(newValue) => onChange?.({...value, value: newValue ?? undefined})}
      placeholder={placeholder ?? 'Numero'}
      style={{width: '100%'}}
      value={value.value}
    />
  )
}

export default UnitSelector
